import {
  EmployeeDto,
  EmployeesInfiniteResponseDto,
  LabourEngagementState,
} from './workforce-service.dto';
import {
  EmployeeCreatePayload,
  employeeDetailSchema,
  EmployeeResponse,
  EmployeesInfiniteResponse,
  employeesInfiniteResponseSchema,
  EmployeeUpdatePayload,
} from './workforce-service.types';
import { OgpApiService } from '../../../ogp/services/ogp-api-service';

export class WorkforceService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getEmployees = async ({
    pageParam,
    labourEngagementStates,
  }: {
    pageParam: number;
    labourEngagementStates?: LabourEngagementState[];
  }): Promise<EmployeesInfiniteResponse> => {
    const value = await this.getEmployeesImpl({ pageParam, labourEngagementStates });
    return employeesInfiniteResponseSchema.parse(value);
  };

  public getEmployee = async (employeeId: string): Promise<EmployeeResponse> => {
    const value = await this.getEmployeeImpl(employeeId);
    return employeeDetailSchema.parse(value);
  };

  private getEmployeeImpl = async (employeeId: string) => {
    return await this.ogpApiService.get<EmployeeDto>({
      path: `workforce/${employeeId}`,
    });
  };

  private getEmployeesImpl = async ({
    pageParam,
    labourEngagementStates,
  }: {
    pageParam: number;
    labourEngagementStates: LabourEngagementState[] | undefined;
  }) => {
    return await this.ogpApiService.get<EmployeesInfiniteResponseDto>({
      path: 'workforce',
      params: {
        page: pageParam,
        pageSize: 25,
        labourEngagementStates,
      },
    });
  };

  public createEmployee = async (employeeData: EmployeeCreatePayload): Promise<string> => {
    return await this.ogpApiService.create<string>({
      path: `workforce`,
      body: employeeData,
    });
  };

  public updateEmployee = async (
    employeeId: string,
    employeeData: EmployeeUpdatePayload
  ): Promise<string> => {
    const { employeeFlexPools, contractStartDate, contractEndDate, contractMinutes } = employeeData;

    return await this.ogpApiService.update<string>({
      path: `workforce/${employeeId}`,
      body: {
        contractStartDate,
        contractEndDate,
        contractMinutes,
        flexPoolIds: employeeFlexPools.map((pool) => pool.id),
      },
    });
  };

  public archiveEmployee = async (employeeId: string): Promise<string> => {
    return await this.ogpApiService.delete<string>({
      path: `workforce/${employeeId}`,
    });
  };

  public resendTemporaryPassword = async (employeeEmail: string): Promise<string> => {
    return await this.ogpApiService.create<string>({
      path: `workforce/${employeeEmail}/resend-temporary-password`,
    });
  };
}
